<div class="header">
    <div class="container-fluid">
      <div class="row ">
        <div class="col-xl-12">
          <h2 class="text-center my-4"><img src="assets\images\olios_logo.png" height="50"  /></h2>
        </div>
      </div>
    </div>
  </div>

<div class="container" style="padding-top:200px;">
    <div class="row justify-content-md-center">
        <div class="col-8 ">
            <div class="box-content">
                <form [formGroup]="form" (ngSubmit)="changePassword()">
                    <div class="login-form" style="padding:20px 50px 50px;">
                        <h4 class=" float-left"><i class="fas fa-unlock-alt mr-1"></i> Forgot Password?</h4>
                        <a class="btn btn-success float-right" href="/login" role="button">Login Page</a>
                        <div class="mt-3" style="padding-top:50px;">
                            
                                <label class="-text"><i class="fas fa-unlock-alt mr-1"></i> New Password</label>
                            
                            <input type="password" class="form-control" formControlName="newPassword" autocomplete="off">
                        </div>
                        <div class="error" *ngIf="form.controls['newPassword'].hasError('required') && form.controls['newPassword'].touched">
                            <h5 class="text-danger mt-1"> field is required</h5>
                        </div>
                        <div class=" mt-3">
                            
                                <label class="-text"><i class="fas fa-unlock-alt mr-1"></i> Retype New Password</label>
                            
                            <input  type="password" class="form-control" formControlName="retypeNewPassword" autocomplete="off">
                        </div>
                        <div class="error"
                            *ngIf="form.controls['retypeNewPassword'].hasError('required') && form.controls['retypeNewPassword'].touched">
                            <h5 class="text-danger mt-1"> field is required</h5>
                        </div>
                        
                        <div class="form-group mt-3">
                            <button class="btn btn-warning" style="width: 100%;" [disabled]="form.invalid"><i class="fas fa-check"></i> Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>